class NavtabController {
    constructor() {
    }

    clickTab(tab) {
        this.tabs.forEach(e => {
            e.active = false
        })
        tab.active = true
        if (typeof(tab.click) == 'function') {
            tab.click();
        }
    }
}

export default NavtabController;



// WEBPACK FOOTER //
// ./src/app/common/navtab/navtab.controller.js